import React from 'react'
import { Outlet } from 'react-router-dom'
import HomeNave from '../components/HomeNav/HomeNave'
import './Home/Home.scss'

export default function Layout({ role }) {

    if (role === "viewer")
        return <>
            <div className=''>
                <HomeNave role={role} />
                <div className="flex flex-col w-full h-full overflow-x-hidden">
                    <Outlet />
                </div>
            </div>
            {/* <Footer /> */}

        </>

    return <>
        <div className='home-flex h-screen'>
            <HomeNave role={role} />
            <div className="flex flex-col w-full h-full overflow-x-hidden">
                <Outlet />
            </div>
        </div>
    </>
}
